<script setup lang="ts">
import { Title } from 'refresh-ui'
import { withQuery } from 'ufo'
const route = useRoute()

defineProps<{
  steps: any
  urls: any
  show: boolean
}>()
</script>

<template>
  <div v-if="show" class="mt-5 rounded-md bg-blue-lighter p-10 text-white">
    <Title :level="2" custom-style="pb-5 lg:text-2xl text-lg">{{ $t('debug.title') }}</Title>
    <ul class="flex flex-wrap gap-4 text-sm text-black">
      <li class="w-full font-bold sm:w-auto">{{ $t('debug.jump-to') }}:</li>
      <li v-for="step in steps" class="">
        <a class="hover:underline" :href="withQuery(route.fullPath, { step: step.key })"
          >{{ step.title }} ({{ step.key }})</a
        >
      </li>
      <li v-if="urls.ok">
        <a class="hover:underline" :href="urls.ok">{{ $t('debug.ok') }}</a>
      </li>
      <li v-if="urls.fail">
        <a class="hover:underline" :href="urls.fail">{{ $t('debug.fail') }}</a>
      </li>
      <li v-if="urls.aborted">
        <a class="hover:underline" :href="urls.aborted">{{ $t('debug.abort') }}</a>
      </li>
      <li v-if="urls.postal">
        <a class="hover:underline" :href="urls.postal">{{ $t('debug.postal') }}</a>
      </li>
    </ul>
  </div>
</template>
